/**
 * Campos de formulario do onboarding, sobre o `Field` do design system.
 *
 * O `Field` cuida de rotulo, dica, erro e dos atributos de acessibilidade; estes dois embrulhos so
 * evitam repetir o render-prop em vinte lugares.
 *
 * A dica NAO e enfeite nesta tela: metade dos campos pede um GUID que vem de outro sistema (Azure,
 * Power BI, Auth), e "onde pegar" e a diferenca entre preencher e travar.
 */

import { Field } from '@ledger-glass/react'

export function CampoTexto({
  id,
  rotulo,
  valor,
  aoMudar,
  dica,
  exemplo,
  obrigatorio,
}: {
  id: string
  rotulo: string
  valor: string
  aoMudar: (valor: string) => void
  dica?: string
  exemplo?: string
  obrigatorio?: boolean
}) {
  return (
    <Field hint={dica} id={id} label={rotulo} required={obrigatorio}>
      {(a11y) => (
        <input
          {...a11y}
          onChange={(evento) => aoMudar(evento.target.value)}
          placeholder={exemplo}
          value={valor}
        />
      )}
    </Field>
  )
}

export interface Opcao {
  valor: string
  rotulo: string
}

export function CampoSelecao({
  id,
  rotulo,
  valor,
  aoMudar,
  opcoes,
  dica,
  vazio,
  obrigatorio,
}: {
  id: string
  rotulo: string
  valor: string
  aoMudar: (valor: string) => void
  opcoes: Opcao[]
  dica?: string
  /** Rotulo da opcao "nenhum". Ausente = a escolha e obrigatoria. */
  vazio?: string
  obrigatorio?: boolean
}) {
  return (
    <Field hint={dica} id={id} label={rotulo} required={obrigatorio}>
      {(a11y) => (
        <select
          {...a11y}
          disabled={opcoes.length === 0 && vazio === undefined}
          onChange={(evento) => aoMudar(evento.target.value)}
          value={valor}
        >
          {vazio === undefined ? null : <option value="">{vazio}</option>}
          {opcoes.map((opcao) => (
            <option key={opcao.valor} value={opcao.valor}>
              {opcao.rotulo}
            </option>
          ))}
        </select>
      )}
    </Field>
  )
}
